module.exports = __webpack_public_path__ + "static/media/right-from-bracket-solid.6ebc1b04.svg";